export default class RelatedProducts {
    constructor(context) {
        this.context = context;

        const products = [].slice.call(document.querySelectorAll('[data-products]'));

        products.forEach((elem) => {
            const {
                dataset: { products },
            } = elem;

            const wrapper = this.context.querySelector(`[data-render="${products}"]`);

            if (wrapper) {
                wrapper.appendChild(elem);
            }
        });
    }
}
